(function () {
  'use strict';

  // Smooth scroll du scroll-indicator vers la section offres
  document.addEventListener('DOMContentLoaded', function () {

    // ─── Multiselect ─────────────────────────────────────────────────────────
    document.querySelectorAll('.multiselect').forEach(function (ms) {
      var trigger  = ms.querySelector('.multiselect__trigger');
      var dropdown = ms.querySelector('.multiselect__dropdown');
      var labelEl  = ms.querySelector('.multiselect__label');
      var defaultLabel = ms.dataset.label || 'Sélectionner';

      function updateLabel() {
        var checked = ms.querySelectorAll('input[type="checkbox"]:checked');
        if (checked.length === 0) {
          labelEl.textContent = defaultLabel;
        } else {
          var noun = ms.dataset.noun || 'élément';
          labelEl.textContent = checked.length + ' ' + noun + (checked.length > 1 ? 's' : '');
        }
        ms.querySelectorAll('.multiselect__option').forEach(function (opt) {
          opt.classList.toggle('is-checked', opt.querySelector('input').checked);
        });
      }

      trigger.addEventListener('click', function () {
        var isOpen = dropdown.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen);
      });

      ms.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', updateLabel);
      });

      // Fermer en cliquant hors du composant
      document.addEventListener('click', function (e) {
        if (!ms.contains(e.target)) {
          dropdown.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });


    // ─── Dropdown "Candidature spontanée" ─────────────────────────────────────
    document.querySelectorAll('.spontaneous').forEach(function (comp) {
      var triggers = comp.querySelectorAll('.spontaneous__trigger');
      var dropdown = comp.querySelector('.spontaneous__dropdown');
      if (!triggers.length || !dropdown) return;

      function setExpanded(state) {
        triggers.forEach(function (t) { t.setAttribute('aria-expanded', state); });
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = dropdown.classList.toggle('is-open');
          setExpanded(isOpen);
        });
      });

      // Fermer en cliquant hors du composant
      document.addEventListener('click', function (e) {
        if (!comp.contains(e.target)) {
          dropdown.classList.remove('is-open');
          setExpanded(false);
        }
      });
    });


    // ─── Persistance des filtres de recherche ─────────────────────────────────
    // Sauvegarde les paramètres URL quand on ouvre une offre
    document.querySelectorAll('.job-card__cta').forEach(function (link) {
      link.addEventListener('click', function () {
        sessionStorage.setItem('langres_search', window.location.search);
      });
    });

    // Restaure les paramètres sur le bouton "Retour aux offres" (page single)
    var backBtn = document.querySelector('.btn-back');
    if (backBtn) {
      var savedSearch = sessionStorage.getItem('langres_search');
      if (savedSearch) {
        var baseUrl = backBtn.href.split('?')[0].replace(/#.*$/, '');
        backBtn.href = baseUrl + savedSearch + '#offres';
      }
    }

    var scrollIndicator = document.querySelector('.hero__scroll-indicator');
    var offresSection = document.querySelector('.offres');

    if (scrollIndicator && offresSection) {
      scrollIndicator.addEventListener('click', function () {
        offresSection.scrollIntoView({ behavior: 'smooth' });
      });
    }

    // Header : ombre portée au scroll
    var header = document.querySelector('.site-header');
    if (header) {
      window.addEventListener('scroll', function () {
        header.classList.toggle('is-scrolled', window.scrollY > 50);
      }, { passive: true });
    }
  });
})();
